/*
  hx-cart-upsell-drawer.js

  Adds an upsell row from snippets/hx-cart-upsell-drawer.liquid to the cart
  without closing the drawer or reloading the page.

  Listens on document rather than on the buttons. Dawn refreshes the drawer by
  assigning innerHTML, which throws away every element inside it and every
  listener bound to one, so anything bound directly would stop working after the
  first add. Delegation from document survives all of it.

  The response asks for the same two sections Dawn's own product form asks for,
  then hands them straight to the drawer's renderContents, so the drawer, the
  header count, the progress bar and the remaining suggestions all update
  together in one paint.

  The header icon fixes (mobile count, mobile tap) live in hx-cart-icon.js so
  they also run on the live notification cart.
*/
(function () {
  var busy = false;

  /* Arrow buttons on the clearance strip, for mouse users. Delegated for the
     same reason as the add buttons: the strip is re-rendered on every add. */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var arrow = event.target.closest('[data-hx-scroll]');
    if (!arrow) return;
    var strip = arrow.closest('.hxc');
    var row = strip && strip.querySelector('.hxc-row');
    if (!row) return;
    event.preventDefault();
    var dir = parseInt(arrow.getAttribute('data-hx-scroll'), 10) || 1;
    row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.8), behavior: 'smooth' });
  });

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var button = event.target.closest('[data-hx-add]');
    if (!button || busy) return;

    event.preventDefault();

    var variantId = parseInt(button.getAttribute('data-hx-add'), 10);
    if (!variantId) return;

    var drawer = document.querySelector('cart-drawer');
    /* The add buttons are now a round icon, so the "Adding" beat goes on the
       marked price text next to it, never on the button itself, or the icon
       would be wiped. The marked span sits inside the card or row the button
       belongs to (data-hx-host), not necessarily inside the button. */
    var host = button.closest('[data-hx-host]') || button;
    var label = host.querySelector('[data-hx-label]') || button;
    var labelText = label.textContent;

    busy = true;
    button.disabled = true;
    label.textContent = 'Adding';

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        /* Shopify answers an out of stock or invalid variant with 4xx and a
           status field rather than by rejecting the promise. */
        if (state.status) throw new Error(state.description || state.message);

        if (drawer && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
        label.textContent = labelText;
      })
      .then(function () {
        busy = false;
      });
  });

  /*
    Priority Dispatch tick box above the checkout button, from
    snippets/hx-priority-box.liquid. Tick adds it, untick removes it, and the
    drawer re-renders in place the same way the add buttons do. The cart page
    has its own copy of the box and handles it in sections/cart-upsell.liquid,
    so anything outside <cart-drawer> is left alone here.
  */
  document.addEventListener('change', function (event) {
    var box = event.target;
    if (!box || !box.hasAttribute || !box.hasAttribute('data-hx-prio')) return;
    var drawer = box.closest('cart-drawer');
    if (!drawer) return;
    if (busy) { box.checked = !box.checked; return; }

    var wrap = box.closest('[data-hx-prio-box]');
    var variantId = parseInt(box.getAttribute('data-hx-prio'), 10);
    var key = box.getAttribute('data-hx-key');
    var url, body;
    if (box.checked) {
      url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      body = { items: [{ id: variantId, quantity: 1 }] };
    } else {
      url = (window.routes && window.routes.cart_change_url) || '/cart/change';
      body = { id: key || String(variantId), quantity: 0 };
    }
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;

    busy = true;
    if (wrap) wrap.setAttribute('aria-busy', 'true');

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message);
        if (state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        box.checked = !box.checked;
        if (wrap) wrap.removeAttribute('aria-busy');
      })
      .then(function () {
        busy = false;
      });
  });

  /*
    The drawer's pictures stay lazy until the drawer is actually opened, then
    they are all told to load at once.

    Leaving them lazy is what keeps them off the critical path: the drawer is
    rendered into every page, so dropping the attribute in the markup would
    download every thumbnail on every visit whether or not anyone opens the
    cart. But lazy alone is not enough once the drawer is open, because the
    clearance row sits below the fold of the drawer's own scroll area and its
    images were still blank when scrolled to.

    Opening is watched on the class attribute rather than hooked onto the open
    method, so it covers every route in: the cart icon, adding from a product
    page, and the upsell buttons in here. The childList watch catches the
    replacement images that arrive with each re-render.
  */
  function warmDrawerImages() {
    var images = document.querySelectorAll('#CartDrawer img[loading="lazy"]');
    for (var i = 0; i < images.length; i++) images[i].removeAttribute('loading');
  }

  function watchDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;

    new MutationObserver(function () {
      if (drawer.classList.contains('active')) warmDrawerImages();
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', watchDrawerOpen);
})();
